import React, { useEffect, useRef, useState } from 'react'
import { EditorState, convertFromRaw, convertToRaw } from 'draft-js'
import draftToHtml from 'draftjs-to-html'

interface TextViewDraftJSProps {
  text: string
}

export function TextViewDraftJS({ text }: Readonly<TextViewDraftJSProps>) {
  const [isExpanded, setIsExpanded] = useState(false)
  const [showButton, setShowButton] = useState(false)
  const contentRef = useRef<HTMLDivElement>(null)

  const draftState = EditorState.createWithContent(
    convertFromRaw(JSON.parse(text))
  )

  const textHtml = draftToHtml(convertToRaw(draftState.getCurrentContent()))

  useEffect(() => {
    const el = contentRef.current

    if (!el) {
      return
    }

    const style = getComputedStyle(el)
    const lineHeight = parseFloat(style.lineHeight || '0')
    const maxHeight = lineHeight * 7

    setShowButton(el.scrollHeight > maxHeight)
  }, [textHtml])

  const containerStyle: React.CSSProperties = isExpanded
    ? {}
    : {
        display: '-webkit-box',
        WebkitLineClamp: 7,
        WebkitBoxOrient: 'vertical',
        overflow: 'hidden',
        textOverflow: 'clip',
      }

  return (
    <div>
      <div
        ref={contentRef}
        style={containerStyle}
        className="text-view-html text-base text-secondary font-inter font-normal leading-6"
        dangerouslySetInnerHTML={{ __html: textHtml }}
      />

      {showButton && (
        <button
          className="underline font-inter text-base font-normal text-restructure-action mt-4 underline-offset-[2px]"
          onClick={() => setIsExpanded((prev) => !prev)}
        >
          {isExpanded ? 'Mostrar menos' : 'Ver mais'}
        </button>
      )}
    </div>
  )
}
